exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".channel-list-template[data-v-470f04a4]{min-height:100px;margin-top:-35px}", ""]);

